import { Center, Flex, Icon, useColorModeValue, Text } from "@chakra-ui/react";
import React, { useContext } from "react";
import { IconType } from "react-icons";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/auth.context";

type Props = {
  icon: IconType;
  children: React.ReactNode;
  to: string;
  groups?: string[];
  colorScheme?: string;
};

const AppIcon = ({
  icon,
  children,
  to,
  groups,
  colorScheme = "lancsBlue",
}: Props) => {
  const bg = useColorModeValue(`${colorScheme}.200`, "whiteAlpha.200");
  const fg = useColorModeValue(`${colorScheme}.500`, `${colorScheme}.300`);
  const { userDetails } = useContext(AuthContext);

  if (
    groups &&
    groups.every((g) => !(userDetails?.["cognito:groups"] ?? []).includes(g))
  ) {
    return null;
  }

  return (
    <Flex
      direction="column"
      justify="center"
      gap={2}
      _hover={{ filter: "brightness(1.1)" }}
      transition=".1s all"
      cursor="pointer"
      as={Link}
      to={to}
      w={16}
    >
      <Center p={4} bg={bg} rounded="xl" transition=".1s all">
        <Icon as={icon} w={8} h={8} color={fg} />
      </Center>
      <Text fontSize="sm" textAlign="center">
        {children}
      </Text>
    </Flex>
  );
};

export default AppIcon;
